module.exports = __webpack_public_path__ + "static/Rosewater4-615303274cdbc4df9213c9d3cd3d3a7d.webp";